import { render } from "./CreateTableBatchModal.vue?vue&type=template&id=71ffc03a"
import script from "./CreateTableBatchModal.vue?vue&type=script&lang=js"
export * from "./CreateTableBatchModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__